
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"248","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 .027v247.716c0-33.15 14.961-46.839 28.81-59.51 10.949-10.018 21.202-19.4 22.814-37.261V96.798c-1.612-17.861-11.866-27.243-22.815-37.261C14.961 46.866 0 33.177 0 .027z","fill":"#ACB7CB"}})])
          )
        }
      }
    